import type { Rule } from './types';

export const cohesionRules: Rule[] = [
  {
    id: 'cohesion.description-promises-met',
    category: 'body',
    severity: 'warn',
    weight: 4,
    title: 'Body delivers on the description\'s promises',
    appliesTo: 'both',
    run(ctx) {
      const desc = ctx.cohesion.descriptionContentTerms.length;
      if (desc === 0) return { status: 'skipped', message: 'No description to check.' };
      if (ctx.bodyText.wordCount < 80) return { status: 'skipped', message: 'Body too short to evaluate cohesion.' };
      const cov = ctx.cohesion.coverage;
      if (cov >= 0.7) return { status: 'pass', message: `${(cov * 100).toFixed(0)}% of description terms appear in body.` };
      if (cov >= 0.5) return { status: 'pass', message: `${(cov * 100).toFixed(0)}% description-to-body overlap.` };
      const missing = ctx.cohesion.hollowPromiseTerms.slice(0, 5).join(', ');
      return {
        status: 'warn',
        message: `Only ${(cov * 100).toFixed(0)}% of description terms show up in the body.`,
        fix: `Hollow promises: ${missing}. Cover them in the instructions, or trim them from the description.`,
      };
    },
  },
  {
    id: 'cohesion.body-expands-on-description',
    category: 'body',
    severity: 'info',
    weight: 2,
    title: 'Body expands beyond the description',
    appliesTo: 'both',
    run(ctx) {
      if (ctx.bodyText.wordCount < 80) return { status: 'skipped', message: 'Body too short.' };
      if (ctx.cohesion.bodyExpandsOnDescription) {
        return { status: 'pass', message: 'Body introduces meaningful detail beyond the description.' };
      }
      return {
        status: 'warn',
        message: 'Body offers little detail beyond what the description already says.',
        fix: 'Expand the body with concrete steps, examples, and edge cases. Don\'t paraphrase the description.',
      };
    },
  },
];
